module.exports = __webpack_public_path__ + "static/work11-f497e929ae64f25fea6e2038aca2e0b5.jpg";